import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';

const COMMUNITY_ROLES_RESOURCE = 'communityRoles';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ROLES_RESOURCE,
      method: 'get',
      request: (communityId, t) => ({
        url: apiRoutes.communityRoles2(communityId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getCommunityRolesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
